<template>
    <div
        v-show="!isHide"
        :class="[
            'floating-container',
            {
                isPC: !isH5
            }
        ]"
        :style="{
            zIndex: zIndex
        }"
    >
        <div :class="['move-container', basePoint]" ref="moveContainerRef">
            <FreeContainer
                class="custom-free-container"
                :children="tpl.children"
                ref="freeContainerRef"
            ></FreeContainer>
        </div>
    </div>
</template>

<script >
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue-demi';
import { isH5 as isH5Fn } from '../utils';
import { BASE_POINT } from '../constant';
import FEGOBridge from '@futuweb/fego-bridge';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
const __sfc_main = {
  name: 'floating-container',
  components: {
    FreeContainer: ComplexComp.Container.Free
  }
};
__sfc_main.props = {
  tpl: Object,
  autoHide: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    rem
  } = FEGOBridge;
  const {
    useHideSituation = () => ({
      isHide: ref(false)
    })
  } = require('@fegobull/webapi').use;
  const DEFAULT_Z_INDEX = 9999;
  const props = __props;
  const {
    isHide
  } = useHideSituation({
    props: props,
    field: 'autoHide'
  });

  // 创建 ref 引用
  const freeContainerRef = ref(null);
  const moveContainerRef = ref(null);
  const isH5 = isH5Fn();
  let listener = null;
  const basePoint = computed(() => {
    return props.tpl.props.basePoint;
  });
  const zIndex = computed(() => {
    const zIndex = props.tpl.props.zIndex;
    if (zIndex === undefined || zIndex === null) {
      return DEFAULT_Z_INDEX;
    }
    return zIndex;
  });
  onMounted(() => {
    setFixed();
  });
  onBeforeUnmount(() => {
    window.removeEventListener('resize', listener);
  });

  // @tips 处理悬浮容器的定位
  // 在 editor 中配置时，h5下的宽高度为 7.5rem / 13.34rem, pc 下为 19.2rem 与 10.8rem
  // h5 下针对底边的场景需要减去配置差值
  // pc 下针对右边的场景且宽度<1920需要减去配置差值 h5 下因为存在等比缩放，所以不需要这步操作
  const setFixed = () => {
    const remStr = rem.rem.str;
    if (isH5) {
      // 如果基准点是底部的 配置里的高度是 13.34rem - 实际需要减掉
      if ([BASE_POINT.BOTTOM_LEFT, BASE_POINT.BOTTOM_RIGHT].includes(basePoint.value)) {
        freeContainerRef.value.$el.style.top = `calc(100vh - 13.34rem)`;
      }
    } else {
      pcResizeListener();
      listener = () => {
        pcResizeListener();
      };
      window.addEventListener('resize', listener);
    }
    nextTick(() => {
      const {
        horizontal,
        vertical,
        basePoint
      } = props.tpl.props;
      const moveContainer = moveContainerRef.value;
      const style = {
        left: 'unset',
        top: 'unset',
        right: 'unset',
        bottom: 'unset'
      };
      if (basePoint === BASE_POINT.TOP_LEFT) {
        style.left = remStr(horizontal);
        style.top = remStr(vertical);
      } else if (basePoint === BASE_POINT.TOP_MID) {
        style.top = remStr(vertical);
      } else if (basePoint === BASE_POINT.TOP_RIGHT) {
        style.top = remStr(vertical);
        style.right = remStr(horizontal);
      } else if (basePoint === BASE_POINT.LEFT_MID) {
        style.left = remStr(horizontal);
      } else if (basePoint === BASE_POINT.RIGHT_MID) {
        style.right = remStr(horizontal);
      } else if (basePoint === BASE_POINT.BOTTOM_LEFT) {
        style.left = remStr(horizontal);
        style.bottom = remStr(vertical);
      } else if (basePoint === BASE_POINT.BOTTOM_MID) {
        style.bottom = remStr(vertical);
      } else if (basePoint === BASE_POINT.BOTTOM_RIGHT) {
        style.right = remStr(horizontal);
        style.bottom = remStr(vertical);
      }
      Object.keys(style).forEach(key => {
        moveContainer.style[key] = style[key];
      });
    });
  };
  const pcResizeListener = () => {
    const {
      width
    } = document.documentElement.getBoundingClientRect();
    // 在右侧的话，左侧偏移量需要减去 19.2rem
    if (width < 1920 && [BASE_POINT.TOP_RIGHT, BASE_POINT.BOTTOM_RIGHT].includes(basePoint.value)) {
      freeContainerRef.value.$el.style.left = `calc(100vw - 19.2rem)`;
    } else {
      freeContainerRef.value.$el.style.left = `unset`;
    }
    if ([BASE_POINT.BOTTOM_LEFT, BASE_POINT.BOTTOM_RIGHT].includes(basePoint.value)) {
      freeContainerRef.value.$el.style.top = `calc(100vh - 10.8rem)`;
    }
  };
  return {
    isHide,
    freeContainerRef,
    moveContainerRef,
    isH5,
    basePoint,
    zIndex
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.floating-container {
    pointer-events: none;
    // 注意 h5 下的要容器居中
    position: fixed !important;
    width: 7.5rem !important;
    height: 100vh !important;
    // @tips 使内容在水平情况下居中
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    margin: auto !important;

    .move-container {
        pointer-events: none;
        width: 7.5rem;
        height: 100vh;
        box-sizing: border-box;
        position: absolute;
        &.top-mid,
        &.bottom-mid {
            left: 50% !important;
            transform: translateX(-50%) !important;
            /deep/ .custom-free-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: absolute !important;
                left: 50% !important;
                transform: translateX(-50%) !important;
                > * {
                    position: static !important;
                }
            }
        }

        &.bottom-mid {
            /deep/ .custom-free-container {
                bottom: 0 !important;
            }
        }

        &.left-mid,
        &.right-mid {
            top: 50% !important;
            transform: translateY(-50%) !important;
            /deep/ .custom-free-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: absolute !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                > * {
                    position: static !important;
                }
            }
        }

        &.right-mid {
            /deep/ .custom-free-container {
                right: 0 !important;
            }
        }

        // 确保内部配置的子元素可交互
        & > * {
            pointer-events: auto;
        }
    }

    &.isPC {
        width: 100vw !important;
        max-width: 19.2rem !important;
        .move-container {
            width: 100vw !important;
            max-width: 19.2rem !important;
        }
    }
}
</style>

